import { http } from '@/app/lib/http/client'

// 1. Interfaz Principal (Como viene de la base de datos/API)
export interface DoctorItem {
    id: number
    full_name: string
    professional_license: string
    address_line1: string
    address_line2: string
    city: string
    state: string
    zip: string
    country: string
    is_active: boolean
    created_at?: string
    updated_at?: string
}

// 2. Interfaz para Crear (Lo que mandas en el POST)
export interface CreateDoctorPayload {
    full_name: string
    professional_license: string
    address_line1: string
    address_line2: string | null
    city: string
    state: string
    zip: string
    country: string
    //is_active: boolean
}

// 3. Interfaz para Editar (Lo que mandas en el PUT, usualmente opcional)
export interface UpdateDoctorPayload {
    full_name?: string
    professional_license?: string
    address_line1?: string
    address_line2?: string | null
    city?: string
    state?: string
    zip?: string
    country?: string
    //is_active?: boolean
}

// 4. El Objeto de Servicio con todas las peticiones
export const doctorsService = {
    // Obtener todos (con paginación/búsqueda opcional)
    async getItems(params?: { per_page?: number; search?: string; page?: number }) {
        const response = await http.get('/pos/doctors', { params }) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Obtener uno solo por ID
    async getItem(id: number) {
        const response = await http.get(`/pos/doctors/${id}`) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Crear
    async createItem(payload: CreateDoctorPayload) {
        const response = await http.post('/pos/doctors', payload) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Actualizar
    async updateItem(id: number, payload: UpdateDoctorPayload) {
        const response = await http.put(`/pos/doctors/${id}`, payload)
        return response.data
    },

    // Cambiar estado (toggle status)
    async toggleStatus(id: number) {
        const response = await http.patch(`/pos/doctors/${id}/toggle-status`)
        return response.data
    },

    // Eliminar
    async deleteItem(id: number) {
        const response = await http.delete(`/pos/doctors/${id}`)
        return response.data
    },
}
